module.exports = __webpack_public_path__ + "img/MBT_R_DEC.7cf8a8fc.png";